import { defineComponent, ref, watch } from '@vue/composition-api';
import { Icon } from '@/components/Icon';
import { mdiChevronDown } from '@mdi/js';
import SelectShownYear from './SelectShownYear.vue';
export default defineComponent({
    components: { Icon, SelectShownYear },
    props: {
        shownYear: {
            type: Number,
            required: false,
        },
        title: {
            type: String,
            required: true,
        },
        defaultExpanded: {
            type: Boolean,
            default: true,
        },
        dotColor: {
            type: String,
            default: null,
        },
        showYearSelector: {
            type: Boolean,
            default: true,
        },
        isIndefinite: {
            type: Boolean,
            default: false,
        },
        collapsible: {
            type: Boolean,
            default: true,
        },
    },
    emits: ['update:shownYear'],
    setup(props, { emit }) {
        const expanded = ref(props.defaultExpanded);
        watch(() => props.defaultExpanded, (newValue) => {
            expanded.value = newValue;
        });
        const toggleExpanded = () => {
            expanded.value = !expanded.value;
        };
        const onUpdateShownYear = (year) => {
            emit('update:shownYear', year);
        };
        return {
            mdiChevronDown,
            expanded,
            toggleExpanded,
            onUpdateShownYear,
        };
    },
});
